import { MemberReportErrors, MembersReportData } from 'fitbeat.models';
import { IMemberReportsRepository } from '../interfaces/imemberreports-repository';

export const BIZTOOLS_DASHBOARD = 'BIZTOOLS_DASHBOARD';
export class DbMemberReportsRepository implements IMemberReportsRepository {
    constructor(private memberReportsDb: any, private generalSettingsDb: any) { }

    public async add(report: MembersReportData): Promise<MembersReportData | MemberReportErrors> {
        const nameInUse = await this.checkName(report.reportName);
        if (nameInUse) {
            return MemberReportErrors.nameExist;
        }
        const doc: any = {
            _id: report.reportId,
            ...report,
        };
        await this.memberReportsDb.put(doc);
        return report;
    }

    public async get(id: string): Promise<MembersReportData | undefined> {
        try {
            const doc = await this.memberReportsDb.get(id);
            return Object.assign(new MembersReportData(), doc);
        } catch (err) {
            if (err.status === 404) {
                return undefined;
            } else {
                throw err;
            }
        }
    }

    public async getAll(): Promise<MembersReportData[]> {
        const results: any = await this.memberReportsDb.allDocs({ include_docs: true });
        const docs: any[] = results
            .rows
            .map((row: any) => row.doc)
            .filter((doc: any) => doc._id !== '0');
        return docs.map((doc: any) => Object.assign(new MembersReportData(), doc));
    }

    public async update(report: MembersReportData): Promise<MembersReportData> {
        const doc: any = await this.get(report.reportId);
        const updateDoc = {
            ...report,
            _id: doc._id,
            _rev: doc._rev,
        };
        await this.memberReportsDb.put(updateDoc);
        return report;
    }

    public async remove(reportId: string): Promise<MembersReportData> {
        const report = await this.get(reportId);
        return this.memberReportsDb.remove(report);
    }

    public async getAllSortedReports(): Promise<string[]> {
        const docs = await this.generalSettingsDb.get(BIZTOOLS_DASHBOARD);
        return docs.reportIdList;
    }

    public async updateSortedReports(reportIdList: string[]): Promise<string[]> {
        try {
            const docs = await this.generalSettingsDb.get(BIZTOOLS_DASHBOARD);
            const sortedReportsList = {
                _id: docs._id,
                _rev: docs._rev,
                reportIdList,
            };
            return await this.generalSettingsDb.put(sortedReportsList);
        } catch (error) {
            throw error;
        }
    }

    private async checkName(reportName: string): Promise<boolean> {
        const result = await this.memberReportsDb.find({
            selector: {
                reportName,
            },
        });
        const docs = result.docs;
        return docs.length !== 0;
    }
}
